import Vue from "vue";
import vuetify from "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Axios from "axios";
import VueGtag from "vue-gtag";

Vue.config.productionTip = false;
Vue.prototype.$http = Axios;
// Vue.prototype.$http.defaults.baseURL = "http://127.0.0.1:3000";
Vue.prototype.$http.defaults.baseURL = "https://trialapi.lifertl.com";
if (process.env.NODE_ENV == "production") {
  Vue.prototype.$http.defaults.baseURL = "https://awsapi.lifertl.com";
  Vue.use(VueGtag, {
    config: { id: "G-DTLE5E8T7X" }
  }, router);
}
if (window.location.hostname == "lotyrtlds.lifertl.com") {
  Vue.prototype.$http.defaults.baseURL = "https://trialapi.lifertl.com";
}

let token = localStorage.getItem("id_token");
if (token) {
  if (!token.startsWith("Bearer ")) {
    token = "Bearer " + token;
  }
  Vue.prototype.$http.defaults.headers.common["Authorization"] = token;
  Vue.prototype.$http.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      // force navigation to login page if status = 401
      if (error.response) {
        if (error.response.status == 401) {
          router.push("/login");
        }
      }
      return error;
    }
  );
}

Vue.prototype.$bus = new Vue()

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount("#app");
